const arrayDataValueTypes = {
  valueType: [
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'Waiting module', description: 'Significa que el SPH esta en estado de espera (Standby)',
    },
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'Self-test mode', description: 'Significa que se está ejecutando una prueba del SPH',
    },
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'Reserved', description: 'Estado reservado por el SPH',
    },
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'SysFault module', description: 'Significa un fallo del sistema SPH',
    },
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'Flash module', description: 'Significa que se activo el modulo flash',
    },
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'Grid and PV online', description: 'Significa que el Panel solar, la batería y la red están en línea. (Panel Solar: On / Batería: On / Red: On)',
    },
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'Grid online and PV offline', description: 'Significa que el Panel solar esta desconectado y la batería y la red están conectados. (Panel Solar: Off / Batería: On / Red: On)',
    },
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'Grid offline and PV online', description: 'Significa que el Panel solar y la batería están conectados y la red está desconectada. (Panel Solar: On / Batería: On / Red: Off)',
    },
    {
      typeId: 'SysM', name: 'System Work Mode', value: 'Bat Offline mode Module', description: 'Significa que la batería está conectada y los paneles solares y la red están desconectados. (Panel Solar: Off / Batería: On / Red: Off)',
    },
    {
      typeId: 'Pri', name: 'Priority', value: 'Load first', description: 'La prioridad es la carga (Load first). Significa que la potencia de la batería y la potencia de los paneles serán consumidas por la carga.',
    },
    {
      typeId: 'Pri', name: 'Priority', value: 'Battery first', description: 'La prioridad es la batería (Battery first). Significa que SPH mantendrá cargada la batería, por lo que la potencia de los panales y la potencia de la red cargarán la batería.',
    },
    {
      typeId: 'Pri', name: 'Priority', value: 'Grid first', description: 'La prioridad es la red (Grid first). Significa la potencia de lo paneles solares y la potencia de la batería se exportarán a la red.',
    },
    {
      typeId: 'BtTy', name: 'Battery type', value: 'Lead - acid', description: 'Batería de litio (Lithium).',
    },
    {
      typeId: 'BtTy', name: 'Battery type', value: 'Lithium battery', description: 'Batería de plomo – acido (Lead – acid)',
    },
    // {
    // typeId: 'SPHS', name: 'Inverter run state', value: 'Waiting',
    // description: 'Batería de plomo – acido (Lead – acid)'
    // },
    {
      typeId: 'Even', name: 'Fault Battery', value: 'OK', description: 'Significa que la batería está conectada',
    },
    {
      typeId: 'Even', name: 'Fault Battery', value: 'FAIL', description: 'Significa que la batería está desconectada',
    },
    {
      typeId: 'EGrid', name: 'Fault Grid', value: 'OK', description: 'Significa que la batería está conectada.',
    },
    {
      typeId: 'EGrid', name: 'Fault Grid', value: 'FAIL', description: 'Significa que la batería está desconectada',
    },
  ],
  valueTypeEvents: [
    {
      name: 'AZURE_ONLINE', value: 1, description: "t('form.condition_rules.AZURE_ONLINE')", label: 'INFO',
    },
    {
      name: 'AZURE_COM', value: 2, description: "t('form.condition_rules.AZURE_COM')", label: 'WARNING',
    },
    {
      name: 'AZURE_ENABLE', value: 3, description: "t('form.condition_rules.AZURE_ENABLE')", label: 'ERROR',
    },
    {
      name: 'SD_OK', value: 4, description: "t('form.condition_rules.SD_OK')", label: 'ERROR',
    },
    {
      name: 'MODBUS_COM', value: 5, description: "t('form.condition_rules.MODBUS_COM')", label: 'ERROR',
    },
    {
      name: 'UPDATED_TIME', value: 6, description: "t('form.condition_rules.UPDATED_TIME')", label: 'WARNING',
    },
    {
      name: 'EXTRTC_OK', value: 7, description: "t('form.condition_rules.EXTRTC_OK')", label: 'ERROR',
    },
    {
      name: 'UPDATING', value: 8, description: "t('form.condition_rules.UPDATING')", label: 'INFO',
    },
    {
      name: 'UPDATE_OK', value: 9, description: "t('form.condition_rules.UPDATE_OK')", label: 'ERROR',
    },
    {
      name: 'HAS_CONN_STR', value: 10, description: "t('form.condition_rules.HAS_CONN_STR')", label: 'ERROR',
    },
    {
      name: 'INTERNET_CONNECTION', value: 11, description: "t('form.condition_rules.INTERNET_CONNECTION')", label: 'INFO',
    },
    {
      name: 'RESET_EVENT', value: 12, description: "t('form.condition_rules.RESET_EVENT')", label: 'WARNING',
    },
    {
      name: 'RESERVED', value: 13, description: "t('form.condition_rules.RESERVED')", label: '',
    },
  ],
};

export default arrayDataValueTypes;
